const ClientPage = () => (<p>Tax Payer Space</p>);

export default ClientPage;
